// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"657":"72ceb564","787":"8bacb779","924":"257f964f"}[chunkId] + ".chunk.js";
};